module.exports = __webpack_public_path__ + "img/arrow_up_square.c7fe4246.svg";